import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router';

import axios from '@/plugins/axios'
import Http from '@/assets/js/https'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    http: Http[process.env.APP_SERVER],
    token: localStorage.getItem('token') ? localStorage.getItem('token') : '',
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : '',
    cartInfo: localStorage.getItem('cartInfo') ? JSON.parse(JSON.stringify(localStorage.getItem('cartInfo'))) : '',
    agreenment: localStorage.getItem('agreenment') ? JSON.parse(localStorage.getItem('agreenment')) : '',
    company: localStorage.getItem('company') ? JSON.parse(localStorage.getItem('company')) : '',
    menuList: sessionStorage.getItem('menuList') ? JSON.parse(sessionStorage.getItem('menuList')) : '',
  },
  mutations: {
    SET_AGREEN(state, agreen) {
      if (agreen) {
        localStorage.setItem('agreenment', JSON.stringify(agreen));
        state.agreenment = agreen;
      } else {
        localStorage.setItem('agreenment', "");
        state.agreenment = "";
      }
      // localStorage.setItem('agreenment', JSON.stringify(agreen));
      // state.agreenment = agreen;
    },
    SET_COMPANY(state, info) {
      localStorage.setItem('company', JSON.stringify(info));
      state.company = info;
    },
    SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_USERINFO(state, info) {
      state.userInfo = info;
    },
    REMOVE_USER(state) {
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
      localStorage.removeItem('cartInfo');
      state.token = "";
      state.userInfo = "";
      state.cartInfo = "";
    },
    SET_CAET(state, info) {
      state.cartInfo = info;
    },
    SET_MENU(state, info) {
      state.menuList = info;
    },
  },
  actions: {
    async getAuthToken({ dispatch, commit, state }, params) {
      let token = params.authToken;
      localStorage.setItem('token', token);
      commit('SET_TOKEN', token);
      axios.defaults.headers.common["Authorization"] = localStorage.getItem('token');
      dispatch('getInfo');
      // await axios.post(`${state.http.api}/v1/auth/refreshauthorization`, params).then(res => {
      //   if (!res.code) {
      //     let token = res.data.authorization;
      //     localStorage.setItem('token', token);
      //     commit('SET_TOKEN', token);
      //     axios.defaults.headers.common["Authorization"] = token;
      //     dispatch('getInfo');
      //   }
      // })
    },
    async getInfo({ commit, state }) {
      await axios.post(`${state.http.api}/v1/user/userinfo`).then(res => {
        if (!res.code) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          commit("SET_USERINFO", res.data);
          router.push('/home');
        }
      })
    },
    async getCart({ commit, state }) {
      await axios
        .post(state.http.api + "/v1/cart/cartindexlist")
        .then((res) => {
          if (!res.code) {
            localStorage.setItem('cartInfo', JSON.stringify(res.data));
            commit("SET_CAET", res.data);
          } else {
            localStorage.removeItem('cartInfo');
            commit("SET_CAET", '');
          }
        });
    },
    async getMenuList({ commit, state }) {
      await axios.post(`${state.http.api}/v1/index/getindexmenu`, {}, {showLoading: false}).then(res => {
        if (!res.code) {
            sessionStorage.setItem('menuList', JSON.stringify(res.data));
            commit("SET_MENU", res.data);
        }
      })
    },
  }

})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js